export default "__VITE_ASSET__DmUKVRVQ__"